import { render, staticRenderFns } from "./registerOfFacilitiesView.vue?vue&type=template&id=7c15d42d&scoped=true"
import script from "./registerOfFacilitiesView.vue?vue&type=script&lang=js"
export * from "./registerOfFacilitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c15d42d",
  null
  
)

export default component.exports